import { AddUser, GetAllData } from "../..";
import { AddLocalDataToFirebase } from "../../AddLocalDataToFirebase";
import { storeSessionData } from "../Session/AddSession";
import { LoginWithAppel } from "./LoginWithAppel"
import { LoginWithFacebook } from "./LoginWithFacebook"
import { LoginWithGoogle } from "./LoginWithGoogle"
import * as actionType from '../../../context/actions'
import { auth, database } from "../../../Utils/firebase";
import { signOut } from "firebase/auth";
import { setcustomUser } from '@softnoesis/shakebug-js';
import { get, ref } from "firebase/database";
import GetRefereeUserDataInFirebase from "../User/GetReferreUserDataInFirebase";
import GetAssignerUserDataInfirebase from "../AssignerUser/GetAssignerUserDataInfirebase";
import { logEvent } from '../../../helper/shakebug';

export const LoginFunc = async (state, dispatch, providerType, DisplayPopup, setIsLoading) => {
    try {
        const urlParams = new URLSearchParams(window.location.search);
        const referralCode = urlParams.get("refferral_code");
        let Authentication_Status = false;
        let Authentication_Data = null;
        let Authentication_Message = null;
        let newUserStatus = false;


        if (providerType === "google") {
            const { sucess, message, data, isNewUser } = await LoginWithGoogle(dispatch, state, referralCode);

            dispatch({ type: actionType.USERID, payload: data?.user_uid })
            Authentication_Status = sucess;
            Authentication_Message = message;
            Authentication_Data = data;
            newUserStatus = isNewUser;
        }
        else if (providerType === "facebook") {
            const { sucess, message, data, isNewUser } = await LoginWithFacebook(dispatch, state, referralCode);
            dispatch({ type: actionType.USERID, payload: data?.user_uid })
            Authentication_Status = sucess;
            Authentication_Message = message;
            Authentication_Data = data;
            newUserStatus = isNewUser;

        }
        else if (providerType === "apple") {
            const { sucess, message, data, isNewUser } = await LoginWithAppel(dispatch, state, referralCode);
            dispatch({ type: actionType.USERID, payload: data?.user_uid })
            Authentication_Status = sucess;
            Authentication_Message = message;
            Authentication_Data = data;
            newUserStatus = isNewUser;
        }

        if (Authentication_Status) {
            const userId = Authentication_Data?.user_uid;
            // await GetRefereeUserDataInFirebase(state, dispatch, Authentication_Data?.referral_code);
            dispatch({ type: actionType.SET_USER, payload: Authentication_Data });
            // Set custom user for ShakeBug crash/feedback reporting
            setcustomUser({
                id: Authentication_Data?.user_uid ?? "",
                name: Authentication_Data?.name ?? "",
                email: Authentication_Data?.email ?? "",
                // country: countryData?.country_name ?? ""
            });

            await AddUser(state, dispatch, userId, Authentication_Data);
            await AddLocalDataToFirebase(state, dispatch, userId);


            localStorage.setItem("AccessUserId", userId);
            localStorage.removeItem("isLocal");
            localStorage.removeItem("LOCAL_BUSINESSES");
            localStorage.removeItem("LOCAL_INVOICES");
            localStorage.removeItem("LOCAL_EXPENSE");
            localStorage.removeItem("LOCAL_SALE_RETURN");
            localStorage.removeItem("LOCAL_EXPENSE");
            localStorage.removeItem("LOCAL_CUSTOMER");
            localStorage.removeItem("LOCAL_ITEM");
            localStorage.removeItem("LOCAL_PROFORMA_INVOICES");
            localStorage.removeItem("LOCAL_QUOTATION");


            await storeSessionData(userId);

            await GetAllData(state, dispatch);

            await GetAssignerUserDataInfirebase(state, dispatch, Authentication_Data?.user_uid)

            setIsLoading(false)

            logEvent("User Login", `${providerType}`);

            // ✅ Redirect after login
            if (newUserStatus) {
                window.location.replace("/thank-you");
            } else {
                window.location.replace("/dashboard");
            }
        }
    } catch (error) {
        setIsLoading(false)
        console.error("Error in LoginFunc:", error);
    }
};

export const LogoutUser = async (dispatch) => {
    try {
        await signOut(auth);
        localStorage.removeItem("AccessUserId");
        localStorage.removeItem("appState");
        localStorage.removeItem("LOCAL_BUSINESSES");
        localStorage.removeItem("LOCAL_INVOICES");
        localStorage.removeItem("LOCAL_EXPENSE");
        localStorage.removeItem("LOCAL_SALE_RETURN");
        localStorage.removeItem("LOCAL_EXPENSE");

        dispatch({ type: actionType.EMPTY_ALL_STATE });

        // ✅ Redirect after logout
    } catch (error) {
        console.error("Logout Error:", error.message);
    }
};             